import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      RECEIPT: "Handlekurv",
      YOUR_ORDER: "Din bestilling",
      PROCEED_TO_CHECKOUT: "Fortsett til utsjekking",
      CLOSE: "Lukk",
    },

    se: {
      RECEIPT: "Varukorg",
      YOUR_ORDER: "Din beställning",
      PROCEED_TO_CHECKOUT: "Fortsätt till kassan",
      CLOSE: "Stäng",
    },

    dk: {
      RECEIPT: "Din indkøbskurv",
      YOUR_ORDER: "Din bestilling",
      PROCEED_TO_CHECKOUT: "Fortsæt til kassen",
      CLOSE: "Luk",
    },
  } as const
)[language];
